import React, { useEffect, useState } from "react";
import style from "./Info.module.scss";
import MiniLineChart from "./MiniLineChart";
import { FormattedNumber } from "../../../../../FormattedNumber/FormattedNumber";

const BoxBonds = ({ items, series }) => {
  const [chart, setChart] = useState(null);

  useEffect(() => {
    const chart = { data: [], percent: 0 };

    series.forEach((serie) => {
      chart.data.push(+serie.Price);
    });

    if (chart.data.length > 1) {
      const v0 = chart.data[chart.data.length - 2];
      const v1 = chart.data[chart.data.length - 1];

      chart.percent = ((v1 - v0) / v0) * 100;

      setChart(chart);
    }
  }, [series]);

  return (
    <div className={style.bonds}>
      <table>
        <tbody>
          {items.AssetName && (
            <tr>
              <td colSpan="2">
                <em>{items.AssetName}</em>
              </td>
            </tr>
          )}

          <tr>
            <td>
              <strong>{items.ISIN || "-"}</strong>
            </td>
            <td>
              {items["Ref Price"] && (
                <React.Fragment>
                  <span>Ref Price:</span>
                  <FormattedNumber
                    value={items["Ref Price"].replaceAll(" ", "").split(":")[1]}
                    decimalScale={items.MaxDecimals}
                    dataTypeDecimalName="price"
                  />
                </React.Fragment>
              )}

              {items["Ref Discount Rate"] && (
                <React.Fragment>
                  <span>Ref Discount Rate:</span>
                  <span>{items["Ref Discount Rate"]}</span>
                </React.Fragment>
              )}
            </td>
          </tr>

          {(items["Ref Discount Rate"] || items.Coupon) && (
            <tr>
              <td>
                <span>Sett. Date:</span>
                <span>{items["Settlment day"] || "-"}</span>
              </td>
              <td>
                <span>Coupon:</span>
                <FormattedNumber value={items.Coupon} dataTypeDecimalName="currency" />
              </td>
            </tr>
          )}

          {(items["Fund Type"] || items["Fund Reinvests"]) && (
            <tr>
              <td>
                <span>Fund Type:</span>
                <span>{items["Fund Type"] || "-"}</span>
              </td>
              <td>
                <span>Fund Reinvests:</span>
                <span>{items["Fund Reinvests"] || "-"}</span>
              </td>
            </tr>
          )}

          {items["Settlment day"] && items.days && (
            <tr>
              <td>
                <span>Last Payment</span>
                <span>{items["Last coupon"] || "-"}</span>
              </td>
              <td>
                <span>Days ago:</span>
                <span>{items.days || "-"}</span>
              </td>
            </tr>
          )}
          <tr>
            <td>
              {items.Maturity && (
                <React.Fragment>
                  <span>Maturity</span>
                  <span>{items.Maturity || "-"}</span>
                </React.Fragment>
              )}
            </td>
            <td>{chart && <MiniLineChart data={chart.data} percent={chart.percent} />}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default BoxBonds;
